import Vue from "vue";
import VueRouter, { NavigationGuardNext, Route } from "vue-router";
import { hasAccessToken } from "./jwt";

Vue.use(VueRouter);

export const backToTop = () => {
  // const message = "不正な遷移を検知しました";
  // Vue.toasted.error(message, {
  //   iconPack: "fontawesome",
  //   icon: "fa-exclamation-circle",
  // });
  // NOTE: 同じパスにいると, NavigationDuplicated が出るので抑制
  router.push({ name: 'Top' }, () => { });
}

const navigationGuardLogin = (
  to: Route,
  from: Route,
  next: NavigationGuardNext
) => {
  if (hasAccessToken()) {
    // ログイン済み
    next();
  } else {
    // 未ログイン
    backToTop();
    next({ name: "Top" });
  }
};

const SITE_TITLE = 'レビュマ（ReviewMarkets）';
const SITE_TITLE_BEFORE = `${SITE_TITLE}｜`;
const SITE_TITLE_AFTER = `｜${SITE_TITLE}`;

const routes = [
  {
    path: "/",
    name: "Top",
    component: () => import("@/views/Top.vue"),
    meta: {
      title: SITE_TITLE_BEFORE + 'IT・プログラミングのコードレビューマッチングサービス',
      desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」のトップページです。こちらから新規依頼やお知らせなどの情報を確認できるほか、アカウント登録やログインも可能です。',
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/forms/Login.vue"),
  },
  {
    path: "/login/corporate",
    name: "CorporateLogin",
    component: () => import("@/views/forms/LoginCorporate.vue"),
  },
  {
    path: "/login/number/auth",
    name: "NumberAuthentication",
    component: () => import("@/views/forms/NumberAuth.vue"),
  },
  {
    path: "/login/mail/auth",
    name: "MailAuthentication",
    component: () => import("@/views/forms/MailAuth.vue"),
  },
  {
    path: "/password/reissue",
    name: "PasswordReissue",
    component: () => import("@/views/forms/PasswordReissue.vue"),
  },
  {
    path: "/password/resetting/:id",
    name: "PasswordResetting",
    component: () => import("@/views/forms/PasswordResetting.vue"),
  },
  {
    path: "/signup",
    name: "Signup",
    component: () => import("@/views/forms/Signup.vue"),
    meta: {
      title: '新規会員登録' + SITE_TITLE_AFTER,
      desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」新規会員登録のページです。フォームに必要事項をご記入・ご選択いただき、利用規約・個人情報の取り扱いに同意のうえお進みください。',
    },
  },
  {
    path: "/signup/send/authNumber/:id",
    name: "PhoneNumberSetting",
    component: () => import("@/views/forms/PhoneNumberSetting.vue"),
  },
  {
    path: "/signup/number/auth",
    name: "SignupNumberAuthentication",
    component: () => import("@/views/forms/NumberAuth.vue"),
  },
  {
    path: "/signup/corporate/:id",
    name: "CorpInformationForm",
    component: () => import("@/views/corporate/forms/CorpInformationForm.vue"),
  },
  {
    path: "/signup/corporate/member/:id",
    name: "CorporateUserValidate",
    component: () => import("@/views/corporate/forms/CorporateUserValidate.vue"),
  },
  {
    path: "/validate/:id",
    name: "Validate",
    component: () => import("@/views/forms/Validate.vue"),
  },
  {
    path: "/search",
    name: "Search",
    component: () => import("@/views/Search.vue"),
    meta: {
      title: '検索' + SITE_TITLE_AFTER,
      desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」の検索ページです。要素（言語）や金額、キーワードからレビュー依頼を検索できます。',
    },
  },
  {
    path: "/review/draft",
    name: "ReviewDraft",
    component: () => import("@/views/review/Edit.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/review/confirm",
    name: "ReviewDraftConfirm",
    component: () => import("@/views/review/Confirm.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/review/payout",
    name: "ReviewDraftPayout",
    component: () => import("@/views/review/Payout.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    // '/review/XXXXX'が'/review/:dealId'で読み取られるため、'/review/XXXXX'より後に設置
    path: "/review/:dealId",
    name: "Review",
    component: () => import("@/views/review/Detail.vue"),
  },
  {
    path: "/review/:dealId/edit",
    name: "ReviewEdit",
    component: () => import("@/views/review/Edit.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/review/:dealId/confirm",
    name: "ReviewConfirm",
    component: () => import("@/views/review/Confirm.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/review/:dealId/payout",
    name: "ReviewPayout",
    component: () => import("@/views/review/Payout.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/mypage",
    name: "Mypage",
    component: () => import("@/views/mypage/MyPageTop.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/mypage/deals",
    name: "DealsManagement",
    component: () => import("@/views/mypage/DealsManagement.vue"),
    beforeEnter: navigationGuardLogin,
    props: true,
  },
  {
    path: "/mypage/payouts",
    name: "SalesManagement",
    component: () => import("@/views/mypage/SalesManagement.vue"),
    beforeEnter: navigationGuardLogin,
    props: true,
  },
  {
    path: "/mypage/settings",
    name: "Settings",
    component: () => import("@/views/mypage/Settings.vue"),
    beforeEnter: navigationGuardLogin,
    props: true,
  },
  {
    path: "/mypage/settings/mailaddress",
    name: "SettingsMailAddress",
    component: () => import("@/views/mypage/forms/MailAddressChange.vue"),
    beforeEnter: navigationGuardLogin,
    props: true,
  },
  {
    path: "/mypage/settings/phoneNumber",
    name: "SettingsPhoneNumber",
    component: () => import("@/views/mypage/forms/PhoneNumberChange.vue"),
    beforeEnter: navigationGuardLogin,
    props: true,
  },
  {
    path: "/mypage/settings/twoFactor",
    name: "TwoFactor",
    component: () => import("@/views/forms/NumberAuth.vue"),
    beforeEnter: navigationGuardLogin,
    props: true,
  },
  {
    path: "/mypage/settings/password",
    name: "SettingsPassword",
    component: () => import("@/views/mypage/forms/PasswordChange.vue"),
    beforeEnter: navigationGuardLogin,
    props: true,
  },
  {
    path: "/mypage/settings/payment",
    name: "SettingsPayment",
    component: () => import("@/views/mypage/forms/PaymentChange.vue"),
    beforeEnter: navigationGuardLogin,
    props: true,
  },
  {
    path: "/deal/:dealId",
    name: "Deal",
    component: () => import("@/views/Deal.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/about",
    name: "About",
    component: () => import("@/views/About.vue"),
    meta: {
      title: 'レビュマとは' + SITE_TITLE_AFTER,
      desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」サービス紹介のページです。プログラミングのコードレビューを依頼したい方と、レビューして報酬を得たい方を結ぶ本サービス概要についてご確認いただけます。',
    },
  },
  {
    path: "/profile/:userId",
    name: "Profile",
    component: () => import("@/views/Profile.vue"),
  },
  {
    path: "/guide",
    name: "",
    component: () => import("@/views/guide/Guide.vue"),
    children: [
      {
        path: "register",
        name: "Register",
        component: () => import("@/views/guide/Register.vue"),
        meta: {
          title: '会員に関する情報-基本情報-' + SITE_TITLE_AFTER,
          desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」会員に関する情報のページです。I会員登録される際の入力項目やアカウントに関する措置などについてはこちらのページをご参照ください。',
        },
      },
      {
        path: "",
        name: "GuideAccept",
        component: () => import("@/views/guide/Accept.vue"),
        meta: {
          title: '使い方ガイド-基本情報-' + SITE_TITLE_AFTER,
          desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」使い方ガイドのページです。レビュー依頼の開始からレビュー金額、手数料、カード決済の支払タイミングなど、レビュマの使い方やルールについて解説しています。',
        },
      },
      {
        path: "accept/prompted",
        name: "GuideAcceptPrompted",
        component: () => import("@/views/guide/AcceptPrompted.vue"),
      },
      {
        path: "accept/tenders",
        name: "GuideAcceptTenders",
        component: () => import("@/views/guide/AcceptTenders.vue"),
        meta: {
          title: '受注までの流れ' + SITE_TITLE_AFTER,
          desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」受注までの流れのページです。レビュー依頼の検索からレビューするまでの流れについて解説しています。',
        },
      },
      {
        path: "accept/deal",
        name: "GuideAcceptDeal",
        component: () => import("@/views/guide/AcceptDeal.vue"),
        meta: {
          title: '取引の流れ（受注）' + SITE_TITLE_AFTER,
          desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」取引の流れ（受注）のページです。 レビューから評価・取引終了までの流れについて解説しています。レビュマで副業したいエンジニアの方は必ずご確認ください。',
        },
      },
      {
        path: "accept/confirm",
        name: "GuideAcceptConfirm",
        component: () => import("@/views/guide/AcceptConfirm.vue"),
        meta: {
          title: '売上金を確認する' + SITE_TITLE_AFTER,
          desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」売上金の確認のページです。売上明細や過去の売上など、売上金に関する情報を確認する手順について解説しています。',
        },
      },
      {
        path: "accept/transfer",
        name: "GuideAcceptTransfer",
        component: () => import("@/views/guide/AcceptTransfer.vue"),
        meta: {
          title: '"売上金の入金' + SITE_TITLE_AFTER,
          desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」売上金の入金のページです。振込先口座の登録や振込手数料、入金処理など売上金の入金に関する情報をご確認いただけます。',
        },
      },
      {
        path: "review/prompted",
        name: "GuideReviewPrompted",
        component: () => import("@/views/guide/ReviewPrompted.vue"),
      },
      {
        path: "review/tenders",
        name: "GuideReviewTenders",
        component: () => import("@/views/guide/ReviewTenders.vue"),
        meta: {
          title: '依頼作成の流れ' + SITE_TITLE_AFTER,
          desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」依頼作成の流れのページです。コードレビューを依頼する方向けに、 依頼内容の入力から入札者を選ぶまでの流れについて解説しています。',
        },
      },
      {
        path: "review/deal",
        name: "GuideReviewDeal",
        component: () => import("@/views/guide/ReviewDeal.vue"),
        meta: {
          title: '取引の流れ（依頼）' + SITE_TITLE_AFTER,
          desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」取引の流れ（依頼）のページです。受注から取引終了までの流れ（ コメントを待つ～ 評価・取引終了）について解説しています。',
        },
      },
      {
        path: "review/edit",
        name: "GuideReviewEdit",
        component: () => import("@/views/guide/ReviewEdit.vue"),
        meta: {
          title: '"依頼の編集・削除' + SITE_TITLE_AFTER,
          desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」依頼の編集・削除のページです。ここではコードレビューを依頼する方向けに、依頼の編集・削除の手順について解説しています。',
        },
      },
      {
        path: "settings",
        name: "GuideSettings",
        component: () => import("@/views/guide/Settings.vue"),
        meta: {
          title: 'プロフィール・スキルの設定' + SITE_TITLE_AFTER,
          desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」プロフィール・スキルの設定のページです。コードレビューを受注するエンジニアの方向けに、プロフィールとスキルの設定手順について解説しています。',
        },
      },
      {
        path: "settings/theme",
        name: "GuideSettingsTheme",
        component: () => import("@/views/guide/SettingsTheme.vue"),
        meta: {
          title: 'コードテーマの設定' + SITE_TITLE_AFTER,
          desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」コードテーマの設定のページです。サイト内のコード表示をダークモードとライトモードの中から選ぶコードテーマの設定手順について解説しています。',
        },
      },
      {
        path: "settings/mailaddress",
        name: "GuideSettingsMailaddress",
        component: () => import("@/views/guide/SettingsMailaddress.vue"),
        meta: {
          title: 'メールアドレスの変更' + SITE_TITLE_AFTER,
          desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」メールアドレスの変更のページです。登録したメールアドレスを変更する手順について解説しています。',
        },
      },
      {
        path: "settings/phoneNumber",
        name: "GuideSettingsPhoneNumber",
        component: () => import("@/views/guide/SettingsPhoneNumber.vue"),
        meta: {
          title: '電話番号の変更' + SITE_TITLE_AFTER,
          desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」電話番号の変更のページです。登録した電話番号を変更する手順について解説しています。',
        },
      },
      {
        path: "settings/password",
        name: "GuideSettingsPassword",
        component: () => import("@/views/guide/SettingsPassword.vue"),
        meta: {
          title: 'パスワードの変更' + SITE_TITLE_AFTER,
          desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」パスワードの変更のページです。登録したパスワードを変更する手順について解説しています。',
        },
      },
      {
        path: "settings/twoFactor",
        name: "TwoFactor",
        component: () => import("@/views/guide/TwoFactor.vue"),
        meta: {
          title: '二要素認証の設定' + SITE_TITLE_AFTER,
          desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」二要素認証のページです。レビュマアカウントのセキュリティを強化できる二要素認証の設定手順について解説しています。',
        },
      },
      {
        path: "settings/leave",
        name: "GuideSettingsLeave",
        component: () => import("@/views/guide/SettingsLeave.vue"),
        meta: {
          title: '退会方法' + SITE_TITLE_AFTER,
          desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」退会方法のページです。退会手順やアカウントを削除する際の注意点について解説しています。',
        },
      },
    ],
  },
  {
    path: "/announcements",
    name: "",
    component: () => import("@/views/announcements/Announcements.vue"),
    children: [
      {
        path: "",
        name: "AnnouncementsList",
        component: () => import("@/views/announcements/List.vue"),
        meta: {
          title: 'お知らせ' + SITE_TITLE_AFTER,
          desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」お知らせのページです。システムメンテナンスや新機能のリリースなど、レビュマからのお知らせをご確認いただけます。',
        },
      },
      {
        path: ":id",
        name: "AnnouncementsDetail",
        component: () => import("@/views/announcements/Detail.vue"),
      },
    ],
  },
  {
    path: "/question",
    name: "Question",
    component: () => import("@/views/Question.vue"),
    meta: {
      title: 'よくある質問' + SITE_TITLE_AFTER,
      desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」よくある質問のページです。料金や売上金、決済エラー、退会などの質問について回答しています。',
    },
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("@/views/Contact.vue"),
    meta: {
      title: 'お問い合わせ' + SITE_TITLE_AFTER,
      desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」お問い合わせのページです。レビュマに関するお問い合わせはこちらのフォームよりお願いいたします。',
    },
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: () => import("@/views/Privacy.vue"),
    meta: {
      title: '個人情報の取り扱い' + SITE_TITLE_AFTER,
      desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」個人情報の取り扱いについてのページです。ReviewMarkets利用における個人情報の取り扱いについてご確認いただけます。',
    },
  },
  {
    path: "/terms",
    name: "Terms.vue",
    component: () => import("@/views/Terms.vue"),
    meta: {
      title: 'ReviewMarkets利用規約' + SITE_TITLE_AFTER,
      desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」利用規約のページです。株式会社アイ・ディ・エイチが提供する「レビュマ」（ReviewMarkets）の利用規約をご確認いただけます。',
    },
  },
  {
    path: "/law",
    name: "Law.vue",
    component: () => import("@/views/Law.vue"),
    meta: {
      title: '特定商取引法に基づく表記' + SITE_TITLE_AFTER,
      desc: 'IT・プログラミングに関する問題解決を解決できるコードレビューマッチングサービス「レビュマ」特定商取引法に基づく表記のページです。皆さまに安心してご利用いただけるよう、提供事業者や価格、引き渡し時期、支払い方法、キャンセルなどの情報を明示しています。',
    },
  },
  {
    path: "/tendersettings/:dealId/create",
    name: "CreateTenderSettings",
    component: () => import("@/views/TenderSettings.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/tendersettings/:dealId/edit",
    name: "EditTenderSettings",
    component: () => import("@/views/TenderSettings.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/tender/:dealId",
    name: "Tender",
    component: () => import("@/views/tender/Tender.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/tender/:dealId/payout",
    name: "TenderPayout",
    component: () => import("@/views/tender/TenderPayout.vue"),
    beforeEnter: navigationGuardLogin,
  },



  // NOTE: 法人関連
  {
    path: "/corporate/settings/notification",
    name: "NoticeSettings",
    component: () => import("@/views/corporate/settings/NoticeSettings.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/corporate/settings/account",
    name: "AccountInfo",
    component: () => import("@/views/corporate/settings/AccountInfo.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/corporate/information/mailaddress",
    name: "CorpMailAddressChange",
    component: () => import("@/views/corporate/forms/MailAddressChange.vue"),
  },
  {
    path: "/corporate/information/password",
    name: "CorpPasswordChange",
    component: () => import("@/views/corporate/forms/PasswordChange.vue"),
  },
  {
    path: "/corporate/information/payment",
    name: "CorpSettingsPayment",
    component: () => import("@/views/corporate/forms/PaymentChange.vue"),
    beforeEnter: navigationGuardLogin,
    props: true,
  },
  {
    path: "/corporate/settings/corpInfo",
    name: "CorpInfo",
    component: () => import("@/views/corporate/settings/CorpInfo.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/corporate/settings/billingStatement",
    name: "BillingStatement",
    component: () => import("@/views/corporate/settings/BillingStatement.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/corporate/settings/payment",
    name: "CorpPaymentForm",
    component: () => import("@/views/corporate/settings/CorpPaymentForm.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/corporate/review/:dealId",
    name: "CorpReview",
    component: () => import("@/views/corporate/Detail.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/corporate/projects/",
    name: "Project",
    component: () => import("@/views/corporate/Project.vue"),
  },
  {
    path: "/corporate/project/:projectId",
    name: "CorpProjectDetail",
    component: () => import("@/views/corporate/ProjectDetail.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/corporate/createpj",
    name: "ProjectCreate",
    component: () => import("@/views/corporate/ProjectEdit.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/corporate/:projectId/edit",
    name: "ProjectEdit",
    component: () => import("@/views/corporate/ProjectEdit.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/corporate/reviews",
    name: "CorpRequest",
    component: () => import("@/views/corporate/Request.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/corporate/member",
    name: "Member",
    component: () => import("@/views/corporate/Member.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/corporate/draft",
    name: "CorpReviewDraft",
    component: () => import("@/views/corporate/Edit.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/corporate/:dealId/edit",
    name: "CorpReviewEdit",
    component: () => import("@/views/corporate/Edit.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/corporate/confirm",
    name: "CorpDraftConfirm",
    component: () => import("@/views/corporate/Confirm.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/corporate/:dealId/confirm",
    name: "CorpConfirm",
    component: () => import("@/views/corporate/Confirm.vue"),
    beforeEnter: navigationGuardLogin,
  },
  {
    path: "/guide/corporate",
    name: "",
    component: () => import("@/views/corporate/guide/Guide.vue"),
    children: [
      {
        path: "",
        name: "GuideAccept",
        component: () => import("@/views/corporate/guide/Accept.vue"),
      },
      {
        path: "/guide/corporate/register",
        name: "GuideCorporateRegister",
        component: () => import("@/views/corporate/guide/Register.vue"),
      },
      {
        path: "/guide/corporate/project/add",
        name: "GuideProjectAddition",
        component: () => import("@/views/corporate/guide/ProjectAddition.vue"),
      },
      {
        path: "/guide/corporate/project/edit",
        name: "GuideProjectEdit",
        component: () => import("@/views/corporate/guide/ProjectEdit.vue"),
      },
      {
        path: "/guide/corporate/project/delete",
        name: "GuideProjectDelete",
        component: () => import("@/views/corporate/guide/ProjectDelete.vue"),
      },
      {
        path: "/guide/corporate/project/list",
        name: "GuideProjectList",
        component: () => import("@/views/corporate/guide/ProjectList.vue"),
      },
      {
        path: "/guide/corporate/deal/list",
        name: "GuidePurchaseList",
        component: () => import("@/views/corporate/guide/PurchaseList.vue"),
      },
      {
        path: "/guide/corporate/deal/create",
        name: "GuidePurchaseCreate",
        component: () => import("@/views/corporate/guide/PurchaseAddition.vue"),
      },
      {
        path: "/guide/corporate/member/list",
        name: "GuideMemberList",
        component: () => import("@/views/corporate/guide/MemberList.vue"),
      },
      {
        path: "/guide/corporate/member/create",
        name: "GuideMemberAddition",
        component: () => import("@/views/corporate/guide/MemberAddition.vue"),
      },
      {
        path: "/guide/corporate/settings/account",
        name: "GuideAccountInfo",
        component: () => import("@/views/corporate/guide/AccountInfo.vue"),
      },
      {
        path: "/guide/corporate/settings/notification",
        name: "GuideNotqificationSettings",
        component: () => import("@/views/corporate/guide/NotificationSettings.vue"),
      },
      {
        path: "/guide/corporate/settings/info",
        name: "GuideCorpInfo",
        component: () => import("@/views/corporate/guide/CorpInfo.vue"),
      },
      {
        path: "/guide/corporate/settings/billing",
        name: "GuideBilling",
        component: () => import("@/views/corporate/guide/Billing.vue"),
      },
    ],
  },


  {
    path: "/:catchAll(.*)",
    name: "Error",
    component: () => import("@/views/error/Error.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
